<template>
  <div class="container">
      <div v-if="!this.$root.registered">
        <div class="title">
        THANKS FOR YOUR SUBMISSSION!
        </div>
        <p class="text"> You've been entered into the draw for a Live Nation $1,000 giftcard.</p>
        <p class="text"> For additional prizes, text "EXCLUSIVE" to 87878 </p>

      </div>

      <div v-else>
        <div class="title">
        THANKS FOR YOUR SUBMISSSION!
        </div>
        <p class="text"> You've already entered into the draw for a Live Nation $1,000 giftcard.</p>
        <p class="text"> For additional prizes, text "EXCLUSIVE" to 87878 </p>
      </div>
      <img src="../assets/Live Nation Image.jpeg" alt="">

  </div>
</template>

<script>
// import axios from 'axios'

export default {

}
</script>

<style scoped>
.container{
  text-align: center;
}
  .title {
    color: white;
    text-align: center;
    font-size: 1.5rem;
  }
  img {
    margin: 3rem 0;
  }
  .text{
    color: white;
    text-align: center;
    font-size: 1.1rem;
    margin: 1.5rem 0;
  }
</style>
